import React from 'react';
import './Agendaheader2.css'; // Importe le CSS
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Agendaheader2() {
  return (
    <div className="header-containerga12a">
        <div className="boutton-containerga12a">
                <div className='butga12a'>
                  
             <button className="bouttonga12a">ACCUEIL<ArrowForwardIcon className="1arrow-icon" />AGENDA</button>
             <h1>AGENDA</h1> 
            </div>
            </div>
    </div>
  );
}

export default Agendaheader2;
